import { Row, Col } from "react-bootstrap";

export default function PageHeader({ title, subtitle, action }) {
  return (
    <Row className="admin-page-header align-items-center g-2">
      <Col>
        <h4 className="admin-page-title">{title}</h4>
        {subtitle && <small className="admin-page-subtitle">{subtitle}</small>}
      </Col>
      {action && <Col xs="auto">{action}</Col>}
    </Row>
  );
}
